type AccountSettingsSectionHeadingProps = {
  title: string;
  subtitle?: string;
};

// Matches the AI Maintenance page heading treatment so both pages read consistently.
export const AccountSettingsSectionHeading = ({ title, subtitle }: AccountSettingsSectionHeadingProps) => (
  <div>
    <p className="font-semibold text-lg py-2">{title}</p>
    {subtitle && <p className="text-sm text-muted-foreground mb-4">{subtitle}</p>}
  </div>
);
